import { Box, Grid, Tooltip, Typography, Card } from "@mui/material";
import theme from "../../utils/theme";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";

interface FloatingCounterProps {
  totalLocationsNumber?: number;
  totalSmartracksLocationsNumber?: number;
  hGrade: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  fontWeight: number;
}

const FloatingCounter = (props: FloatingCounterProps) => {
  const { t } = useTranslation();
  return (
    <Card
      sx={{ backgroundColor: "transparent", border: "none", boxShadow: "none" }}
    >
      <Grid container direction={"row"} sx={{ p: 1 }}>
        <Grid>
          <Typography
            variant={props.hGrade}
            sx={{
              fontWeight: props.fontWeight,
              color: "#000000",
            }}
          >
            {(props.totalLocationsNumber ?? -1 > 0)
              ? props.totalLocationsNumber
              : "..."}
          </Typography>
        </Grid>
        <Grid>
          <Typography variant={props.hGrade} sx={{ textAlign: "center" }}>
            |
          </Typography>
        </Grid>
        <Grid size="auto">
          <Typography
            variant={props.hGrade}
            color="primary"
            sx={{ fontWeight: props.fontWeight }}
          >
            {(props.totalSmartracksLocationsNumber ?? -1 > 0)
              ? props.totalSmartracksLocationsNumber
              : "..."}
          </Typography>
        </Grid>
        <Grid size="auto" sx={{ pl: 1 }}>
          <Box sx={{ paddingTop: theme.spacing(1.5) }}>
            <Tooltip disableFocusListener title={`${t("counterBtn")}`}>
              <InfoOutlinedIcon
                sx={{
                  fontSize: "15px",
                  paddingLeft: theme.spacing(0.5),
                  color: "#000000",
                }}
              />
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};

export default FloatingCounter;
